// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRecircFooter_root__1r-hg","main":"ArticleRecircFooter_main__3CdX_","rightRail":"ArticleRecircFooter_rightRail__2Hagl"};